if (!customElements.get("switch-column")) {
  customElements.define(
    "switch-column",
    class SwitchColumn extends HTMLElement {
      static MOBILE_WIDTH_BREAKPOINT = 600;

      constructor() {
        super();
      }

      connectedCallback() {
        this.initialize();
      }

      initialize() {
        this.container = this.querySelector(
          ".collection__mobile-layout-switch",
        );
        this.loader = this.querySelector(".loading-overlay");
        this.checkInput = document.querySelector(
          ".collection__mobile-layout-checkbox",
        );
        this.gridButton = this.container.querySelector(".css-icon--grid");
        this.squareButton = this.container.querySelector(".css-icon--square");
        this.sortCustomSelect = document.querySelector(
          '[data-reference-id="SortBy"]',
        );

        this.boundChangeNumberOfColumns = this.changeNumberOfColumns.bind(this);
        this.boundHandleResize = this.handleResize.bind(this);
        this.boundHandleLoad = this.handleLoad.bind(this);

        this.addEventListeners();

        if (window.innerWidth < SwitchColumn.MOBILE_WIDTH_BREAKPOINT) {
          this.setNumberOfColumns();
        }
      }

      addEventListeners() {
        window.addEventListener("load", this.boundHandleLoad);
        window.addEventListener("resize", this.boundHandleResize);
        if (this.sortCustomSelect) {
          this.sortCustomSelect.addEventListener(
            "wtSelectChange",
            this.boundHandleLoad,
          );
        }
        if (this.checkInput) {
          this.checkInput.addEventListener(
            "change",
            this.boundChangeNumberOfColumns,
          );
        }
      }

      removeEventListeners() {
        window.removeEventListener("load", this.boundHandleLoad);
        window.removeEventListener("resize", this.boundHandleResize);
        if (this.checkInput) {
          this.checkInput.removeEventListener(
            "change",
            this.boundChangeNumberOfColumns,
          );
        }
        if (this.sortCustomSelect) {
          this.sortCustomSelect.removeEventListener(
            "wtSelectChange",
            this.boundHandleLoad,
          );
        }
      }

      handleLoad() {
        this.loader.classList.add("loading-overlay--hidden");
        this.container.classList.remove(
          "collection__mobile-layout-switch--hidden",
        );
        if (window.innerWidth < SwitchColumn.MOBILE_WIDTH_BREAKPOINT) {
          this.setNumberOfColumns();
        }
      }

      handleResize() {
        const grid = this.getGrid();
        if (!grid) return;
        if (
          window.innerWidth >= SwitchColumn.MOBILE_WIDTH_BREAKPOINT &&
          grid.style.getPropertyValue("--cols")
        ) {
          grid.style.removeProperty("--cols");
          const desktopCols = localStorage.getItem('productGridColumns') || '2';
          grid.classList.remove('vista-1', 'vista-2', 'vista-4', 'is-mobile');
          grid.classList.add('vista-' + desktopCols, 'is-desktop');
        } else if (window.innerWidth < SwitchColumn.MOBILE_WIDTH_BREAKPOINT) {
          if (!this.loader.classList.contains("loading-overlay--hidden")) {
            this.loader.classList.add("loading-overlay--hidden");
          }
          if (
            this.container.classList.contains(
              "collection__mobile-layout-switch--hidden",
            )
          ) {
            this.container.classList.remove(
              "collection__mobile-layout-switch--hidden",
            );
          }
          this.setNumberOfColumns();
        }
      }

      takeFromLocalStorage() {
        return localStorage.getItem("numberOfColumns");
      }

      setInLocalStorage(value) {
        localStorage.setItem("numberOfColumns", value);
      }

      getNumberOfColumns() {
        if (this.dataset.designMode === "true") {
          return this.dataset.col;
        } else {
          const valueFromLocalStorage = this.takeFromLocalStorage();
          const value =
            valueFromLocalStorage !== null
              ? valueFromLocalStorage
              : this.dataset.col;
          return value;
        }
      }

      getGrid() {
        return document.querySelector('.collection__grid');
      }

      applyViewClasses(colsNumber) {
        const grid = this.getGrid();
        if (!grid) return;
        grid.classList.remove('vista-1', 'vista-2', 'vista-4');
        grid.classList.add('vista-' + colsNumber);
        grid.classList.add('is-mobile');
        grid.classList.remove('is-desktop');
      }

      setNumberOfColumns() {
        const stored = localStorage.getItem('numberOfColumns');
        const vistaNumber = stored !== null ? stored : (this.dataset.col || '1');
        const grid = this.getGrid();
        if (!grid) return;

        if (this.checkInput) {
          this.checkInput.checked = vistaNumber === '2';
        }

        grid.style.setProperty("--cols", vistaNumber);
        grid.setAttribute('data-mobile-cols', vistaNumber);
        this.applyViewClasses(vistaNumber);
        this.dataset.col = vistaNumber;
        this.changeColorOfButtons();
      }

      changeNumberOfColumns() {
        const newValue = this.checkInput && this.checkInput.checked ? '2' : '1';
        const grid = this.getGrid();
        if (!grid) return;

        grid.style.setProperty("--cols", newValue);
        grid.setAttribute('data-mobile-cols', newValue);
        this.setInLocalStorage(newValue);
        this.applyViewClasses(newValue);
        this.dataset.col = newValue;
        this.changeColorOfButtons();

        if (window.analyticsUtils && window.analyticsUtils.pushGridViewEventToDataLayer) {
          window.analyticsUtils.pushGridViewEventToDataLayer(newValue);
        }
      }

      changeColorOfButtons() {
        const colsNumber = this.getNumberOfColumns();
        const primaryColor = "var(--color-text)";
        const secondaryColor = "var(--color-border)";

        this.squareButton.style.setProperty(
          "--icon-color",
          colsNumber === "1" ? primaryColor : secondaryColor,
        );
        this.gridButton.style.setProperty(
          "--icon-color",
          colsNumber === "2" ? primaryColor : secondaryColor,
        );
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }
    },
  );
}
